'use client'

import { createContext, PropsWithChildren, useContext, useState } from 'react'

export type CreateCompanyType = 'broker' | 'haulier' | 'shipper'

export type OpenCreateCompanySheetOptions = {
  defaultType?: CreateCompanyType
}

type Context = {
  closeCreateCompanySheet: () => void
  formKey: number
  isOpen: boolean
  openCreateCompanySheet: (options?: OpenCreateCompanySheetOptions) => void
  options: null | OpenCreateCompanySheetOptions
}

const CreateCompanySheetContext = createContext<Context | null>(null)

export const CreateCompanySheetProvider = ({ children }: PropsWithChildren) => {
  const [formKey, setFormKey] = useState(0)
  const [isOpen, setIsOpen] = useState(false)
  const [options, setOptions] = useState<Context['options']>(null)

  const closeCreateCompanySheet = () => {
    setIsOpen(false)
    setOptions(null)
  }

  const openCreateCompanySheet = (nextOptions?: OpenCreateCompanySheetOptions) => {
    setOptions(nextOptions ?? null)
    setFormKey(currentValue => currentValue + 1)
    setIsOpen(true)
  }

  return (
    <CreateCompanySheetContext.Provider
      value={{
        closeCreateCompanySheet,
        formKey,
        isOpen,
        openCreateCompanySheet,
        options,
      }}
    data-sentry-element="CreateCompanySheetContext.Provider" data-sentry-component="CreateCompanySheetProvider" data-sentry-source-file="context.tsx">
      {children}
    </CreateCompanySheetContext.Provider>
  )
}

export const useCreateCompanySheet = () => {
  const context = useContext(CreateCompanySheetContext)

  if (!context) {
    throw new Error('useCreateCompanySheet must be used within a CreateCompanySheetProvider')
  }

  return context
}
